<template>
  <div class="index" ref="index"  @scroll="onSroll"><!--  @touchmove="touchmove"-->
    <div class="header">
      <div class="top_head">
        <img src="../assets/logo.png" alt="">
        <span>空间原力</span>
      </div>
      <div class="bottom">
        <div>空间原力</div>
        <img src="../assets/sf.png" alt="">
      </div>
      <div class="body">
        <div>
          <p>融合型空间资产</p>
          <p>管理解决方案</p>
        </div>
        <div>INTELLIGENT PROPERTY MANAGEMENT SOLUTION</div>
        <div>软硬件一体化集成的智慧空间资产管理综合解决方案帮助管理经营决策，挖掘提升资产价值。</div>
      </div>
    </div>
    <div class="top_head">
        <img src="../assets/logo.png" alt="">
        <span>应用场景</span>
    </div>
    <carrousel/>
    <div class="top_head" style="margin-top:15px;">
        <img src="../assets/logo.png" alt="">
        <span>我们的优势</span>
    </div>
    <div class="you_shi">
      <h4>整合型全流程业务自动处理</h4>
      <div>
        <div>
          <img src="../assets/icon_03.gif" alt="">
          <p>告别EXCEL</p>
          <p>管理流程信息化</p>
        </div>
        <div>
          <img src="../assets/icon_06.gif" alt="">
          <p>大数据分析</p>
          <p>优化运营资产</p>
        </div>
        <div>
          <img src="../assets/icon_15.gif" alt="">
          <p>IoT物联网</p>
          <p>一键管理声光电</p>
        </div>
        <div>
          <img src="../assets/icon_17.gif" alt="">
          <p>账单自动生成</p>
          <p>收付款便捷管理</p>
        </div>
        <div>
          <img src="../assets/icon_09.gif" alt="">
          <p>预警到期合同</p>
          <p>系统自动化处理</p>
        </div>
        <div>
          <img src="../assets/icon_19.png" alt="">
          <p>数据权限隔离</p>
          <p>管理灵活安全</p>
        </div>
      </div>
    </div>
    <div class="top_head">
        <img src="../assets/logo.png" alt="">
        <span>核心价值</span>
    </div>
    <div class="jia_zhi">
      <div>
        <img src="../assets/icon-2_03.gif" alt="">
        <div>
          <h4>增加</h4>
          <p>盈利点</p>
        </div>
      </div>
      <div>
        <img src="../assets/icon-2_05.gif" alt="">
        <div>
          <h4>提高</h4>
          <p>入驻率</p>
        </div>
      </div>
      <div>
        <img src="../assets/icon-2_10.gif" alt="">
        <div>
          <h4>降低</h4>
          <p>运营成本</p>
        </div>
      </div>
      <div>
        <img src="../assets/icon-2_13.png" alt="">
        <div>
          <h4>节省</h4>
          <p>能源损耗</p>
        </div>
      </div>
    </div>
    <div class="top_head" style="background-color:#ffdb80;color:#5d6b75;">
        <img src="../assets/logo.png" alt="">
        <span>产品与服务</span>
    </div>
    <div class="fu_wu">
      <div class="fu_wu_left"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_left">全景大数据分析</h4>
      <p class="fu_wu_left">多维度对空间运营做数据分析，为运营管理的优化决策提供依据</p>
       <div class="fu_wu_left"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_left">空间可视化管理</h4>
      <p class="fu_wu_left">空间平面化管理，联动运营招商宣传，在服务全流程中贯穿一键操作与可视化</p>
      <div class="fu_wu_left"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_left">招商管理</h4>
      <p class="fu_wu_left">基于渠道引流建立空间服务，传递招商信息，根据招商结果完成自动结佣</p>
      <div class="fu_wu_left"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_left">租赁合同及账单管理</h4>
      <p class="fu_wu_left">合同线上签约审核，监测租期降低空置，自动生成租金报表，实时查看缴费情况</p>
      <div class="fu_wu_right"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_right fu_wu_h4">物业管理</h4>
      <p class="fu_wu_right">基于物业收费及物业服务的管理，提供便捷的物业服务工具</p>
      <div class="fu_wu_right"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_right fu_wu_h4">资产库存管理</h4>
      <p class="fu_wu_right">基于RFID技术，对资产进行全生命周期的管理，实现快速资产盘点与清算</p>
      <div class="fu_wu_right"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_right fu_wu_h4">会员/社群管理</h4>
      <p class="fu_wu_right">提供空间专属的线上活动以及企业服务对接，为租户提供更丰富的社交价值</p>
      <div class="fu_wu_right"><div class="fu_wu_icon"></div></div>
      <h4 class="fu_wu_right fu_wu_h4">IOT物联网硬件管理</h4>
      <p class="fu_wu_right">深度集成智能硬件设备，实现智能声光电、空调管控等场景，节省能耗成本</p>
    </div>
    <div class="step_3">
      <h4>三步，开启空间管理新时代</h4>
      <p>我们提供项目评估与经营分析、空间智能化管理系统部署、基于软硬件配合的智能化IOT物联网络、综合经营托管与合作服务。</p>
    </div>
    <div class="three_step">
      <div>部署空间原力系统和智能化改造</div>
      <img src="../assets/d_1.png" alt="">
      <div>
        <div>制定基于实际经营情况的合作方案</div>
        <div>项目方试用系统并进行验收</div>
      </div>
    </div>
    <div class="top_head">
        <img src="../assets/logo.png" alt="">
        <span>合作伙伴</span>
    </div>
    <div class="huo_ban">
      <img src="../assets/u253.png" alt="">
    </div>
    <div class="line"></div>
    <div class="lian_xi">
      <h4>联系我们</h4>
      <div>
        <div>
          <div>
            <img src="../assets/i_2.png" alt="">
            <div>028-62825272</div>
          </div>
          <div>
            <img src="../assets/i_3.png" alt="">
            <div>INFO@SPACESFORCE.COM</div>
          </div>
          <div>
            <img src="../assets/i_4.png" alt="">
            <div>四川省成都市金牛区蜀西路42号A1栋</div>
          </div>
      </div>
      </div>
    </div>
    <div class="down">@2018 Spacesforce All Right Reserved</div>
    <div style="height:49px;"></div>
    <!-- button -->
    <div class="button" v-show="isFree" @click="toBeFree">免费试用</div>
    <!-- 蒙层 -->
    <div class="modal" v-show="isMeng" @click="closeMeng">
      <div @click.stop>
        <div class="form" @click.stop="closeCallBack" v-show="showForm">
          <h4>申 请 免 费 试 用</h4>
          <div class="input">
            <div><input type="text" v-model="form.name" placeholder="您的姓名"></div>
            <div><input type="text" v-model="form.company" placeholder="公司名称"></div>
            <div><input type="text" v-model="form.post" placeholder="您的职位"></div>
            <div><input type="text" v-model="form.size" placeholder="您要管理的空间面积(㎡)"></div>
            <div><input type="text" v-model="form.email" placeholder="邮箱地址"></div>
            <div>
              <input type="number" v-model="form.phone" @input="phoneChange" placeholder="请输入手机号">
              <div class="get_code" @click.stop="getCode">{{isSendCode?timer+"s":"获取验证码"}}</div>
            </div>
            <div>
              <input type="number" v-model="form.code" placeholder="请输入验证码">
            </div>
          </div>
          <div class="err_word">{{err_word}}</div>
          <div class="sure_button"><div @click.stop="isOK">确 认</div></div>
        </div>
        <div class="call_back" v-show="callBack">
          <img src="../assets/i_1.png" alt="">
          <p>您的申请已提交成功！我们会尽快与您联系，请您耐心等待。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carrousel from "./Swiper.vue";
import { testPhone, testEmail } from "../main.js";
import axios from "axios";
var instance = axios.create();
instance.defaults.timeout = 10000;
instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
export default {
  name: "WaluntIndex",
  components: {
    carrousel
  },
  props: ["label", "value", "msg"],
  model: {
    prop: "checked",
    event: "change"
  },
  data: function() {
    return {
      phoneLength: 11,
      new_msg: this.msg,
      clientHeight: "",
      isMeng: false,
      callBack: false,
      isFree: false,
      showForm: true,
      err_word: "",
      form: {
        name: "",
        company: "",
        post: "",
        email: "",
        size: "",
        phone: "",
        code: ""
      },
      isSendCode: false,
      timer: 60
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  methods: {
    isOK() {
      var form = this.form;
      var that = this;
      console.log("form", form);
      if (!form.name) {
        this.err_word = "请输入姓名";
        return;
      }
      if (!form.company) {
        this.err_word = "请输入公司";
        return;
      }
      if (!form.post) {
        this.err_word = "请输入职位";
        return;
      }
      if (!form.size) {
        this.err_word = "请输入面积";
        return;
      }
      if (!form.email) {
        this.err_word = "请输入邮箱";
        return;
      }
      if (!testEmail(form.email)) {
        this.err_word = "邮箱格式错误";
        return;
      }
      if (!form.phone) {
        this.err_word = "请输入手机号";
        return;
      }
      if (!testPhone(form.phone)) {
        this.err_word = "手机格式错误";
        return;
      }
      if (!form.code) {
        this.err_word = "请输入验证码";
        return;
      }
      axios
        .post("https://m.spacesforce.com/api/free/addFreeTail", {
          name: form.name,
          phone: form.phone,
          company: form.company,
          email: form.email,
          management_area: form.size,
          position: form.post,
          code: form.code
        })
        .then(function(response) {
          console.log("response", response);
          if (response.data.error_code == 0) {
            that.callBack = true;
            that.showForm = false;
            setTimeout(function() {
              that.callBack = false;
              that.isMeng = false;
              that.showForm = true;
            }, 3000);
          } else {
            that.err_word = response.data.data.msg;
          }
        })
        .catch(function(error) {
          console.log("error", error);
          that.err_word = "申请失败";
        });
      TDAPP.onEvent("点击_申请免费试用确认");
    },
    closeCallBack() {
      this.callBack = false;
    },
    phoneChange(e) {
      var value = e.target.value + "";
      if (value.length > 11) {
        this.form.phone = value.substr(0, 11);
      }
    },
    getCode() {
      var phone = this.form.phone;
      var isPhone = testPhone(phone);
      console.log("isPhone", isPhone);
      var that = this;
      if (isPhone) {
        this.err_word = "";
        if (this.isSendCode) {
          return false;
        }
        axios
          .post("https://m.spacesforce.com/api/sms/sendSmsFreeTrail", {
            phone: phone
          })
          .then(function(response) {
            console.log("response", response);
            if (response.data.error_code == 0) {
              that.err_word = "";
              that.isSendCode = true;
              var i = 60;
              var timer = setInterval(function() {
                console.log(1);
                if (i <= -1) {
                  clearInterval(timer);
                  that.isSendCode = false;
                } else {
                  var time = parseInt(i);
                  that.timer = time;
                  --i;
                }
              }, 1000);
            } else {
              this.err_word = response.data.data.msg;
            }
          })
          .catch(function(error) {
            console.log("error", error);
            that.err_word = "发送失败";
          });
      } else {
        this.err_word = "手机格式错误";
      }
    },
    toBeFree() {
      console.log("clientHeight", this.clientHeight);
      this.isMeng = true;
      this.callBack = false;
      this.showForm = true;
      this.err_word = "";
      TDAPP.onEvent("点击_免费试用");
    },
    closeMeng() {
      this.isMeng = false;
      this.callBack = false;
    },
    touchmove(e) {
      var scrollTop = e;
      console.log(scrollTop);
    },
    onSroll(e) {
      var scrollTop = e.target.scrollTop;
      console.log(scrollTop);
      if (scrollTop < this.clientHeight) {
        if (this.isFree == false) {
          return;
        } else {
          this.isFree = false;
        }
      } else {
        if (this.isFree == true) {
          return;
        } else {
          this.isFree = true;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: 99;
}
.header {
  width: 100%;
  height: 100%;
  background: url(../assets/bg_1.png) no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
}
.header .body {
  padding: 30px;
  text-align: left;
  color: #fff;
}
.header .body > div:nth-child(1) {
  font-family: H-MingLan-Regular;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 2px;
  font-weight: bold;
  margin-bottom: 10px;
}
.header .body > div:nth-child(2) {
  font-family: Helvetica, roboto;
  font-size: 13.774px;
  text-transform: uppercase;
  line-height: 16px;
  letter-spacing: 1px;
  margin-bottom: 30px;
}
.header .body > div:nth-child(3) {
  font-family: H-MingLan-Regular;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 1px;
  color: #fefefe;
}
.header > div:nth-child(1) {
  position: absolute;
  top: 0;
  left: 0;
}
.header .bottom {
  position: absolute;
  bottom: 30px;
  left: 30px;
  display: flex;
  align-items: center;
  font-weight: bold;
}
.header .bottom > div:nth-child(1) {
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #ffffff;
  font-weight: bold;
}
.header .bottom > img {
  height: 22px;
  margin-top: 3px;
}
.header .bottom > div:nth-child(2) > div:nth-child(2) {
  box-shadow: -4px -11px 21px 8px rgba(12, 4, 7, 0.16);
}
.top_head {
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #ffffff;
  display: flex;
  align-items: center;
  background-color: #5d6b75;
  width: 100%;
  font-weight: bold;
}
.top_head > img {
  height: 31px;
  margin: 15px 5px 15px 15px;
}
.you_shi {
  padding: 40px 20px 10px;
  background-color: #fff;
}
.you_shi > h4 {
  font-family: H-MingLan-Bold;
  font-size: 16px;
  letter-spacing: 1px;
  color: #707070;
  margin-bottom: 30px;
}
.you_shi > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.you_shi > div > div {
  text-align: center;
  margin-bottom: 30px;
  width: 33.33%;
}
.you_shi > div > div img {
  height: 66px;
  margin-bottom: 5px;
}
.you_shi > div > div p {
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #545454;
}
.jia_zhi {
  padding: 40px 40px 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
}
.jia_zhi > div {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.jia_zhi > div img {
  height: 33px;
  margin-right: 5px;
}
.jia_zhi > div p {
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #545454;
}
.jia_zhi > div h4 {
  font-family: H-MingLan-Regular;
  font-size: 18px;
  color: #545454;
  margin-bottom: 2px;
}
.fu_wu {
  background: url(../assets/bg_2.png) no-repeat center center;
  background-size: cover;
  padding: 20px;
}
.fu_wu > div,
.fu_wu > h4,
.fu_wu > p {
  margin-bottom: 10px;
  width: 70%;
  text-align: left;
}
.fu_wu > h4 {
  font-size: 16px;
  color: #fff;
  font-family: H-MingLan-Bold;
  letter-spacing: 1px;
}
.fu_wu > p {
  font-size: 12px;
  color: #fff;
  font-family: H-MingLan-Regular;
}
.fu_wu:after {
  content: "";
  display: block;
  clear: both;
}
.fu_wu .fu_wu_left {
  float: left;
}
.fu_wu .fu_wu_right {
  float: right;
}
.fu_wu .fu_wu_icon {
  width: 17px;
  height: 3px;
  background-color: #ffdb80;
}
.fu_wu .fu_wu_left .fu_wu_icon {
  float: left;
}
.fu_wu .fu_wu_right .fu_wu_icon {
  float: right;
}
.fu_wu .fu_wu_h4 {
  text-align: right;
}
.step_3 {
  padding: 30px;
  background-color: #ffdb80;
}
.step_3 > h4 {
  font-family: H-MingLan-Bold;
  font-size: 23px;
  letter-spacing: 2px;
  color: #545454;
  margin-bottom: 15px;
}
.step_3 > p {
  text-align: left;
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #797979;
}
.three_step {
  padding: 30px;
  background-color: #fff;
}
.three_step > div:nth-child(1) {
  font-family: H-MingLan-Bold;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #ffdb80;
  max-width: 33.33%;
  margin: 0 auto;
}
.three_step > img {
  width: 90%;
  display: block;
  border: 0;
  margin: 10px auto;
}
.three_step > div:nth-child(3) {
  font-family: H-MingLan-Bold;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.three_step > div:nth-child(3) > div:nth-child(1) {
  max-width: 33.33%;
  color: #9bc4ca;
}
.three_step > div:nth-child(3) > div:nth-child(2) {
  max-width: 33.33%;
  color: #566f85;
}
.huo_ban {
  background-color: #fff;
}
.huo_ban img {
  width: 100%;
}
.line {
  width: 100%;
  height: 15px;
  background-color: #eeeeee;
}
.lian_xi {
  padding: 30px;
  background-color: #fff;
}
.lian_xi > h4 {
  font-family: H-MingLan-Bold;
  font-size: 23px;
  letter-spacing: 4px;
  color: #797979;
  margin-bottom: 30px;
}
.lian_xi > div {
  display: flex;
  justify-content: space-around;
}
.lian_xi > div > div > div {
  display: flex;
  align-items: center;
  font-family: Helvetica, roboto;
  font-size: 12px;
  letter-spacing: 1px;
  color: #797979;
  margin-bottom: 5px;
}
.lian_xi > div > div > div > img {
  width: 14px;
  margin-right: 10px;
}
.down {
  padding: 10px;
  font-family: Helvetica, roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #c5c5c5;
  background-color: #fff;
}
.button {
  font-family: PingFangHK-Medium;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #333333;
  position: fixed;
  z-index: 110;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffdb80;
  width: 100%;
  display: flex;
  justify-content: space-around;
  line-height: 49px;
}
.modal {
  position: fixed;
  z-index: 120;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  overflow-y: scroll;
  -webkit-overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
}
.modal > div {
  width: 90%;
  margin: 0 auto;
  position: relative;
}
.modal .form {
  background-color: #fff;
  padding: 20px;
}
.modal .form > h4 {
  font-family: H-MingLan-Bold;
  font-size: 16px;
  letter-spacing: 0px;
  color: #545454;
  margin-bottom: 30px;
}
.modal .form > .input > div {
  margin: 0 20px;
  padding: 15px 0;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
}
.modal .form > .input > div .get_code {
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #333333;
  word-break: keep-all;
  min-width: 80px;
  background-color: #ffdb80;
  border-radius: 25px;
  padding: 5px 0;
}
.modal .form > .input input {
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  width: 100%;
}
.modal .err_word {
  height: 25px;
  line-height: 25px;
  text-align: left;
  padding-left: 20px;
  margin-top: 5px;
  font-family: H-MingLan-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #d83c3c;
  word-break: keep-all;
}
.modal .sure_button {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
}
.modal .sure_button > div {
  background-color: #ffdb80;
  font-family: H-MingLan-Regular;
  font-size: 16px;
  letter-spacing: 0px;
  color: #545454;
  padding: 10px 50px;
  border-radius: 20px;
  font-weight: bold;
}
.modal .call_back {
  padding: 30px 30px 50px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  margin-top: -100px;
  left: 0;
  font-family: H-MingLan-Regular;
  font-size: 12px;
  line-height: 25px;
  letter-spacing: 0px;
  color: #545454;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.modal .call_back img {
  height: 41px;
  margin-bottom: 20px;
}
</style>
